module.exports = __webpack_public_path__ + "img/toys.a41436.svg";